import tagsApi from "../modules/notes/api/TagsApi"
import { storeAccountTags } from "./AppStore"
import { store } from "./store"

const updateAccountTagsStore = () => {
    tagsApi.getAccountTags()
    .then(data => {
        store.dispatch(storeAccountTags(data))
    })
}

export {updateAccountTagsStore}